import { createAction } from 'typesafe-actions';

export const selectYear = createAction('payrollTickets/SELECT_YEAR')<number>();
